import { render, staticRenderFns } from "./BaseConsulta.vue?vue&type=template&id=68ae61f6"
import script from "./BaseConsulta.vue?vue&type=script&lang=js"
export * from "./BaseConsulta.vue?vue&type=script&lang=js"
import style0 from "./BaseConsulta.vue?vue&type=style&index=0&id=68ae61f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports